import { entityAnimationState } from './animation-state';
import { activeDeploymentZones } from './placement';
import type { ArenaDefinition, BattleState, BattleView, EntityId, EntityState, PlayerId } from './types';

const otherSide = (side: PlayerId): PlayerId => side === 'player' ? 'bot' : 'player';

export function createBattleView(state: BattleState, arena: ArenaDefinition, viewer: PlayerId): BattleView {
  const opponent = state.players[otherSide(viewer)];
  const entityById = (id: EntityId | null): EntityState | null => id === null ? null : state.entities.find((entity) => entity.id === id && !entity.removed) ?? null;
  return {
    tick: state.tick,
    phase: state.phase,
    arena: arena.gameplay,
    deploymentZones: structuredClone(activeDeploymentZones(arena.gameplay, viewer, state.entities)),
    player: structuredClone(state.players[viewer]),
    opponent: { id: opponent.id, crowns: opponent.crowns },
    entities: state.entities.filter((entity) => !entity.removed).map((entity) => {
      const animation = entityAnimationState(entity, entityById(entity.targetId));
      return {
        id: entity.id, owner: entity.owner, kind: entity.kind, cardId: entity.sourceCardId,
        x: entity.position.x, y: entity.position.y, hp: entity.hp, maxHp: entity.maxHp,
        radius: entity.radius, movement: entity.movement, moving: animation.moving,
        attacking: animation.attacking, leaping: entity.leapState !== null,
        deploying: entity.deployRemaining > 0, active: entity.active, dead: entity.dead,
        targetId: entity.targetId, visualKey: entity.visualKey,
      };
    }),
    projectiles: structuredClone(state.projectiles.filter((projectile) => !projectile.dead)),
    result: state.result ? structuredClone(state.result) : null,
  };
}
